import { styled } from '@mui/material/styles';

import { Box } from '../../atoms/Box';

import { COLORS } from '../../../configs/colors';

export const RestrictionBox = styled(Box)`
  width: 95%;
  padding: 20px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-top:15px;
  margin-left:15px;
  margin-right:15px;
`;
